import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {ReceiptsFilter} from '../components/receipts-filter/ReceiptsFilter';
import {ReceiptsTable} from '../components/receipts-table/ReceiptsTable';
import {ReceiptsFooter} from '../components/receipts-footer/ReceiptsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function ReceiptsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'receipts-list-card'}>
      <ReceiptsFilter/>
      <ReceiptsTable/>
      <FooterBar>
        <ReceiptsFooter/>
      </FooterBar>
    </Card>
  );
}
